<template>
  <div>
    <div class="contentList">
      <div style="padding: 0 5%; margin: 0.3rem auto 0.2rem">
        <el-form
          ref="form"
          label-width="1rem"
          :rules="rules"
          :model="addAdminObj"
        >
          <el-form-item label="联系方式:" prop="phone">
            <el-input
              @input="debouncedInputComplete2"
              placeholder="请输入联系方式"
              :disabled="isSee"
              v-model="addAdminObj.phone"
            ></el-input>
            <div class="form-tip">
              用户联系方式为管理员登录账号，默认密码为1a2a3a
            </div>
          </el-form-item>
          <el-form-item label="管理员名称:" prop="name">
            <el-input
              maxlength="20"
              @input="debouncedInputComplete"
              placeholder="请输入管理员名称"
              :disabled="isSee"
              v-model="addAdminObj.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属学校:" prop="schoolId">
            <el-select
              :disabled="isSee"
              style="width: 100%;"
              clearable
              @change="
                checkAdmin();
                debouncedInputComplete();
              "
              v-model="addAdminObj.schoolId"
              placeholder="请选择所属学校"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管理员类型:" prop="adminType">
            <el-select
              :disabled="isSee"
              style="width: 100%;"
              clearable
              @change="checkAdmin2"
              v-model="addAdminObj.adminType"
              placeholder="请选择管理员类型"
            >
              <el-option
                v-for="item in adminType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="form-tip" v-if="showAdminTip">
              当前学校已存在校级管理员，请重新选择
            </div>
          </el-form-item>
        </el-form>

        <div class="auth-information">
          <div class="auth-information-title">认证信息</div>
          <div class="auth-information-imgs">
            <el-upload
              class="upload-demo"
              :class="{ disabled: eqObj.uploadDisabled }"
              :on-change="fileChange"
              :on-preview="handlePreview"
              :on-success="uploadSuccess"
              :on-remove="handleRemove"
              :action="uploadConfig.uploadurl"
              :headers="uploadConfig.uploadHeaders"
              :file-list="uploadConfig.fileList"
              accept=".jpg,.png"
              list-type="picture-card"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">
                身份证正面
              </div>
            </el-upload>
            <el-upload
              class="upload-demo"
              :class="{ disabled: eqObj.uploadDisabled2 }"
              :on-change="fileChange2"
              :on-preview="handlePreview"
              :on-success="uploadSuccess2"
              :on-remove="handleRemove2"
              :action="uploadConfig.uploadurl"
              :headers="uploadConfig.uploadHeaders"
              :file-list="uploadConfig.fileList2"
              accept=".jpg,.png"
              list-type="picture-card"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">
                身份证反面
              </div>
            </el-upload>
            <el-upload
              class="upload-demo"
              :class="{ disabled: eqObj.uploadDisabled3 }"
              :on-change="fileChange3"
              :on-preview="handlePreview"
              :on-success="uploadSuccess3"
              :on-remove="handleRemove3"
              :action="uploadConfig.uploadurl"
              :headers="uploadConfig.uploadHeaders"
              :file-list="uploadConfig.fileList3"
              accept=".jpg,.png"
              list-type="picture-card"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">
                个人工作证
              </div>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  provinceAndCityDataPlus,
  TextToCode,
  CodeToText
} from "element-china-area-data";
import {
  AddAdminApi,
  GetUserDataApi,
  DetermineThisAdminExistsApi,
  GetThisSchoolLevelAdminSituationApi
} from "@/request/requestApi";
import { debounce, throttle } from "lodash";

export default {
  props: {
    isSee: {
      default: false
    },
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    currAdminInfo: {}
  },
  data() {
    return {
      dialogVisible: true,
      addAdminObj: {
        name: "",
        phone: "",
        isUpdate: true,
        schoolId: "",
        adminType: 0,
        imgFront: "",
        imgReverse: "",
        imgWork: ""
      },
      showAdminTip: false,
      adminType: [
        { name: "校级管理员", value: 0 },
        { name: "教职工管理员", value: 1 }
        // { name: "学生管理员", value: 2 }
      ],
      schoolList: [],
      apiUrl: "",
      options: provinceAndCityDataPlus,
      userData: { glY_XY: [], glY_JZG: [] },
      address: ["", ""],
      eqObj: {
        uploadDisabled: false,
        uploadDisabled2: false,
        uploadDisabled3: false
      },
      uploadConfig: {
        uploadurl: "",
        fileList: [],
        fileList2: [],
        fileList3: [],
        uploadHeaders: {
          Authorization: localStorage.getItem("token")
        }
      },
      // 表单校验规则
      rules: {
        name: [
          { required: true, message: "请输入管理员名称", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "联系电话格式不正确",
            trigger: "blur"
          }
        ],
        schoolId: [
          { required: true, message: "请选择所属学校", trigger: "change" }
        ],
        adminType: [
          { required: true, message: "请选择管理员类型", trigger: "change" }
        ]
      }
    };
  },

  created() {
    this.apiUrl = `${window.api.apiurl}`;
    this.uploadConfig.uploadurl = `${window.api.apiurl}/api/Common/UploadFile`;
    this.getSchoolList();
    this.debouncedInputComplete = debounce(this.checkAdminType, 250); // 使用防抖
    this.debouncedInputComplete2 = debounce(this.changePhone, 250); // 使用防抖
  },
  methods: {
    async changePhone(phone) {
      let res = await GetUserDataApi({ Phone: phone });
      if (res.succeed) {
        this.addAdminObj.name = "";
        if (res.data.situation) {
          this.addAdminObj.name = res.data.name;
        }
        this.checkAdminType();
      }
    },
    resetForm() {},
    async determineHandle() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.showAdminTip)
            return this.$message.error(
              "当前学校已存在校级管理员，请重新选择！"
            );
          let params = {
            name: this.addAdminObj.name,
            phone: this.addAdminObj.phone,
            schoolId: this.addAdminObj.schoolId
          };
          let res = await DetermineThisAdminExistsApi(params);
          if (res.succeed) {
            if (res.data.situation) {
              this.dialogVisible = true;
              this.$parent.$parent.openSuerPop();
              // this.$confirm(
              //   "系统中已存在相同账号数据，是否直接将该用户设置为管理员并更新认证信息？",
              //   "提示",
              //   {
              //     confirmButtonText: "确定",
              //     cancelButtonText: "仅设置为管理员",
              //     type: "warning"
              //   }
              // )
              //   .then(() => {
              //     this.addAdminHandle(true);
              //   })
              //   .catch(() => {
              //     this.addAdminHandle(false);
              //   });
            } else {
              this.$confirm("确定添加此管理员吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.addAdminHandle(true);
                })
                .catch(() => {});
            }
          }
        }
      });
    },
    async checkAdminType() {
      if (
        this.addAdminObj.name &&
        this.addAdminObj.phone &&
        this.addAdminObj.schoolId
      ) {
        let params = {
          name: this.addAdminObj.name,
          phone: this.addAdminObj.phone,
          schoolId: this.addAdminObj.schoolId
        };
        let res = await DetermineThisAdminExistsApi(params);
        if (res.succeed) {
          if (res.data.adminType == -1) this.addAdminObj.adminType = undefined;
          else this.addAdminObj.adminType = res.data.adminType;
        } else {
          this.addAdminObj.adminType = undefined;
        }
      }
    },
    async addAdminHandle(isUpdate) {
      let params = {
        ...this.addAdminObj,
        isUpdate: isUpdate // 根据需要设置其他参数
      };
      AddAdminApi(params).then(res => {
        if (res.succeed) {
          this.$message.success("操作成功");
          this.$parent.$parent.closeAdminBtn();
        } else {
          this.$message.error(res.error);
        }
      });
    },
    async checkAdmin(val) {
      this.showAdminTip = false;
      let params = { Id: val };
      let res = await GetThisSchoolLevelAdminSituationApi(params);
      if (res.succeed) {
        if (res.data.situation && this.addAdminObj.adminType === 0) {
          this.showAdminTip = true;
        }
      }
    },
    async checkSameAdmin(name, phone, schoolId) {
      let params = { name: name, phone: phone, schoolId: schoolId };
      let res = await DetermineThisAdminExistsApi(params);
      if (res.succeed) {
        return res.data.situation;
      }
    },
    async checkAdmin2(val) {
      this.showAdminTip = false;
      let params = { Id: this.addAdminObj.schoolId };
      let res = await GetThisSchoolLevelAdminSituationApi(params);
      if (res.succeed) {
        if (res.data.situation && val === 0) {
          this.showAdminTip = true;
        }
      }
    },
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };
      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    getAddress(value1, value2) {
      this.schoolProvince = TextToCode[value1][value2].code;
      console.log(this.schoolProvince);
    },
    init() {
      this.uploadConfig.fileList = [];
      this.getSchoolList();
      // this.uploadConfig.fileList.push({
      //   url: `${window.api.apiurl}${this.userData.logo}`
      // });
    },
    handleChange(value) {
      console.log(value);
      var dz = [];
      if (value[1] != null) {
        dz.push(CodeToText[value[0]]);
        if (CodeToText[value[1]] == "全部") dz.push("");
        else dz.push(CodeToText[value[1]]);
      } else {
        if (CodeToText[value[0]] == "全部") dz.push("");
        else dz.push(CodeToText[value[0]]);
      }
      this.address = dz;
      console.log(this.address);
    },
    //文件改变钩子函数
    fileChange(file, fileList) {
      // 这是关键一句
      if (fileList.length > 0) {
        this.eqObj.uploadDisabled = true;
        this.uploadConfig.fileList = [fileList[fileList.length - 1]];
      }
    },
    //文件改变钩子函数
    fileChange2(file, fileList) {
      // 这是关键一句
      if (fileList.length > 0) {
        this.eqObj.uploadDisabled2 = true;
        this.uploadConfig.fileList2 = [fileList[fileList.length - 1]];
      }
    },
    //文件改变钩子函数
    fileChange3(file, fileList) {
      // 这是关键一句
      if (fileList.length > 0) {
        this.eqObj.uploadDisabled3 = true;
        this.uploadConfig.fileList3 = [fileList[fileList.length - 1]];
      }
    },
    //已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
    },
    //文件上传成功
    uploadSuccess(file, fileList) {
      // this.userData.logo = file.data;
      this.addAdminObj.imgFront = file.data;
    },
    uploadSuccess2(file, fileList) {
      // this.userData.logo = file.data;
      this.addAdminObj.imgReverse = file.data;
    },
    uploadSuccess3(file, fileList) {
      // this.userData.logo = file.data;
      this.addAdminObj.imgWork = file.data;
    },
    //移除文件
    handleRemove(file, fileList) {
      this.eqObj.uploadDisabled = false;
      this.addAdminObj.imgFront = "";
    },
    handleRemove2(file, fileList) {
      this.eqObj.uploadDisabled2 = false;
      this.addAdminObj.imgReverse = "";
    },
    handleRemove3(file, fileList) {
      this.eqObj.uploadDisabled3 = false;
      this.addAdminObj.imgWork = "";
    }
  },
  watch: {
    currAdminInfo: {
      handler(val) {
        if (val) {
          this.addAdminObj.name = val.name;
          this.addAdminObj.phone = val.phone;
          this.addAdminObj.schoolId = val.schoolId;
          this.addAdminObj.adminType = val.adminType;
          this.addAdminObj.imgFront = val.imgFront;
          this.addAdminObj.imgReverse = val.imgReverse;
          this.addAdminObj.imgWork = val.imgWork;
          if (val.imgFront)
            this.uploadConfig.fileList.push({
              url: `${window.api.apiurl}${val.imgFront}`
            });
          if (val.imgReverse)
            this.uploadConfig.fileList2.push({
              url: `${window.api.apiurl}${val.imgReverse}`
            });
          if (val.imgWork)
            this.uploadConfig.fileList3.push({
              url: `${window.api.apiurl}${val.imgWork}`
            });
        }
      },
      deep: true, // 启用深度监测
      immediate: true // 立即执行
    },
    "uploadConfig.fileList": {
      handler(val) {
        if (val.length) {
          this.eqObj.uploadDisabled = true;
        }
      },
      deep: true, // 启用深度监测
      immediate: true // 立即执行
    },
    "uploadConfig.fileList2": {
      handler(val) {
        if (val.length) {
          this.eqObj.uploadDisabled2 = true;
        }
      },
      deep: true, // 启用深度监测
      immediate: true // 立即执行
    },
    "uploadConfig.fileList3": {
      handler(val) {
        if (val.length) {
          this.eqObj.uploadDisabled3 = true;
        }
      },
      deep: true, // 启用深度监测
      immediate: true // 立即执行
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled >>> .el-upload.el-upload--picture-card {
  display: none !important;
}

.contentList {
  .form-tip {
    font-weight: 400;
    font-size: 0.14rem;
    color: #ff6767;
  }
  .auth-information {
    display: flex;
    flex-direction: column;
    .auth-information-title {
      margin-bottom: 0.18rem;
      font-weight: 400;
      font-size: 0.18rem;
      color: #333333;
    }
    .auth-information-imgs {
      display: flex;
      justify-content: space-between;
      .el-upload__tip {
        margin-top: 0.18rem;
        font-size: 0.14rem;
        text-align: center;
      }
    }
  }
  img.headerImg {
    border: 1px solid #dedede;
    width: 1rem;
    height: 1rem;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 50%;
  }
  .names {
    span {
      min-width: 0.6rem;
      white-space: nowrap;
      display: inline-block;
    }
  }
  .el-cascader {
    width: 100%;
  }
  .el-upload-list__item {
    transition: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/userManagement/components/addAdmin.vue